import React, { useEffect, useState } from "react";
import styles from "./Assessment.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { updateNewAssessmentVariable } from "../../../redux/slices/globalVariableSlice";
import Navbar from "../../layout/header/Header";
import Pagination from "../../layout/pagination/Pagination";
import { AssesmentResponse } from "../../../shared/models";
// import responseData from "./../../../shared/responses.json";
import "bootstrap/dist/css/bootstrap.min.css";
import { getAllAssessments } from "../../../api/services/assessment-apis";
import { assessmentDetails } from "../../../shared/share-data";
import { toast } from "react-toastify";

const Assessment: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const CACHE_EXP_TIME = 10000000;
  const [getAssesmentData, setAssessmentData] = useState(
    // responseData.getAssesment
    assessmentDetails[0] || []
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState({
    setId: "",
    setName: "",
    createdBy: "",
    domain: "",
    status: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    getAllAssessments()
      .then((data) => {
        // console.log(data)
        setAssessmentData(data.data);
        assessmentDetails.push(data.data);
      })
      .catch((error) => {
        toast.error(error);
        console.log(error);
      });
  }, []);

  const handleClick = (item: any) => {
    // console.log(item);
    navigate("/approval-screen", {
      state: { flag: true, AssessmentDetails: item },
    });
  };

  const handleNewAssessmentClick = () => {
    navigate("/assessment/new-set", {
      state: { flag: false, assessData: getAssesmentData },
    });
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSearch((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const sortedData = [...getAssesmentData].sort(
    (a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
  );

  // console.log(sortedData);

  const filteredData = sortedData.filter((item) =>
    Object.keys(search).every((key) => {
      const itemValue = item[key as keyof typeof item];
      const searchValue = search[key as keyof typeof search];
      return (
        itemValue &&
        itemValue.toString().toLowerCase().includes(searchValue.toLowerCase())
      );
    })
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  if (error) {
    return (
      <div className="error">
        <h3>Something went wrong!</h3>
      </div>
    );
  }

return (
  <div className={styles.assessment}>
    <Navbar />
    <div className={styles.assessment__page}>
      <div className={styles.assessment__page__table__container}>
        <table>
          <thead>
            <tr>
              <td>SRLNO</td>
              <td>SetName</td>
              <td>Created By</td>
              <td>Domain</td>
              <td>Status</td>
            </tr>
          </thead>
          <tbody>
            {/* Search inputs row */}
            <tr>
              <td>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    name="setId"
                    value={search.setId}
                    onChange={handleSearchChange}
                    style={{
                      width: "80%", // Smaller width
                      padding: "0.2rem", // Smaller padding
                      border: "1px solid #000", // Thin black border
                      borderRadius: "4px",
                      backgroundColor: "#fff", // Light background
                      color: "#000", // Dark text for contrast
                      textIndent: search.setId ? "0" : "-9999px", // Show text when typing
                    }}
                  />
                  {!search.setId && ( // Conditionally render the icon
                    <i
                      className="fa-solid fa-magnifying-glass"
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)", // Centers the icon
                        color: "#000", // Dark icon for contrast
                      }}
                    ></i>
                  )}
                </div>
              </td>
              <td>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    name="setName"
                    value={search.setName}
                    onChange={handleSearchChange}
                    style={{
                      width: "80%", // Smaller width
                      padding: "0.2rem", // Smaller padding
                      border: "1px solid #000", // Thin black border
                      borderRadius: "4px",
                      backgroundColor: "#fff", // Light background
                      color: "#000", // Dark text for contrast
                      textIndent: search.setName ? "0" : "-9999px", // Show text when typing
                    }}
                  />
                  {!search.setName && ( // Conditionally render the icon
                    <i
                      className="fa-solid fa-magnifying-glass"
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)", // Centers the icon
                        color: "#000", // Dark icon for contrast
                      }}
                    ></i>
                  )}
                </div>
              </td>
              <td>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    name="createdBy"
                    value={search.createdBy}
                    onChange={handleSearchChange}
                    style={{
                      width: "80%", // Smaller width
                      padding: "0.2rem", // Smaller padding
                      border: "1px solid #000", // Thin black border
                      borderRadius: "4px",
                      backgroundColor: "#fff", // Light background
                      color: "#000", // Dark text for contrast
                      textIndent: search.createdBy ? "0" : "-9999px", // Show text when typing
                    }}
                  />
                  {!search.createdBy && ( // Conditionally render the icon
                    <i
                      className="fa-solid fa-magnifying-glass"
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)", // Centers the icon
                        color: "#000", // Dark icon for contrast
                      }}
                    ></i>
                  )}
                </div>
              </td>
              <td>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    name="domain"
                    value={search.domain}
                    onChange={handleSearchChange}
                    style={{
                      width: "80%", // Smaller width
                      padding: "0.2rem", // Smaller padding
                      border: "1px solid #000", // Thin black border
                      borderRadius: "4px",
                      backgroundColor: "#fff", // Light background
                      color: "#000", // Dark text for contrast
                      textIndent: search.domain ? "0" : "-9999px", // Show text when typing
                    }}
                  />
                  {!search.domain && ( // Conditionally render the icon
                    <i
                      className="fa-solid fa-magnifying-glass"
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)", // Centers the icon
                        color: "#000", // Dark icon for contrast
                      }}
                    ></i>
                  )}
                </div>
              </td>
              <td>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    name="status"
                    value={search.status}
                    onChange={handleSearchChange}
                    style={{
                      width: "80%", // Smaller width
                      padding: "0.2rem", // Smaller padding
                      border: "1px solid #000", // Thin black border
                      borderRadius: "4px",
                      backgroundColor: "#fff", // Light background
                      color: "#000", // Dark text for contrast
                      textIndent: search.status ? "0" : "-9999px", // Show text when typing
                    }}
                  />
                  {!search.status && ( // Conditionally render the icon
                    <i
                      className="fa-solid fa-magnifying-glass"
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)", // Centers the icon
                        color: "#000", // Dark icon for contrast
                      }}
                    ></i>
                  )}
                </div>
              </td>
            </tr>

            {/* Data rows */}
            {currentItems.map((item: AssesmentResponse, index: number) => (
              <tr
                key={item.setId.toString()}
                onClick={() => handleClick(item)}
                style={{ cursor: "pointer" }}
              >
                <td style={{ textAlign: "center" }}>{indexOfFirstItem + index + 1}</td>
                <td>{item.setName}</td>
                <td>{item.createdBy}</td>
                <td>{item.domain}</td>
                <td>
                  {item.status.toLowerCase() === "approved" ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        className={styles.approved}
                        src={require("../../../images/approved.png")}
                        alt="approved"
                      />
                      <div>Approved</div>
                    </div>
                  ) : item.status.toLowerCase() === "rejected" ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        className={styles.approved}
                        style={{
                          width: "22px",
                        }}
                        src={require("../../../images/rejected.png")}
                        alt="rejected"
                      />
                      <div>Rejected</div>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className={styles.pending}></div>
                      <div>{item.status}</div>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          paginate={paginate}
          projectsPerPage={itemsPerPage}
          totalProjects={filteredData.length}
          currentPage={currentPage}
        />
      </div>
      <div className={styles.assessment__page__btn}>
        <button onClick={handleNewAssessmentClick}>New Assessment +</button>
      </div>
    </div>
  </div>
);
};

export default Assessment;
